import { MAIN_RECIPE_ELEMENTS, SECONDARY_RECIPE_ELEMENTS, TASTE_RECIPE_PROPERTIES, LIQUID_RECIPE_ELEMENTS } from '../components/helper';
import { ITEM_TAB_NAME, RECIPE_TAB, TABLET_WIDTH } from '../constant';
import i18n from '../i18nService';

const checkActiveRoute = (activeRoute, pageUrl) => {
    return activeRoute === pageUrl;
};

const createRecipeIngredientsTabs = (id, width, activeRoute, i18nInstance = i18n) => {
    return [
        {
            pageUrl: `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${MAIN_RECIPE_ELEMENTS}`,
            title: i18nInstance.t('app.page.recipe.base'),
            isActive: checkActiveRoute(activeRoute, `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${MAIN_RECIPE_ELEMENTS}`),
        },
        {
            pageUrl: `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${SECONDARY_RECIPE_ELEMENTS}`,
            title: i18nInstance.t(width <= TABLET_WIDTH ? 'app.page.recipe.addsShort' : 'app.page.recipe.adds'),
            isActive: checkActiveRoute(activeRoute, `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${SECONDARY_RECIPE_ELEMENTS}`),
        },
        {
            pageUrl: `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${LIQUID_RECIPE_ELEMENTS}`,
            title: i18nInstance.t(width <= TABLET_WIDTH ? 'app.page.recipe.liquidShort' : 'app.page.recipe.liquid'),
            isActive: checkActiveRoute(activeRoute, `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${LIQUID_RECIPE_ELEMENTS}`),
        },
        {
            pageUrl: `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${TASTE_RECIPE_PROPERTIES}`,
            title: i18nInstance.t(width <= TABLET_WIDTH ? 'app.page.recipe.tastyShort' : 'app.page.recipe.tasty'),
            isActive: checkActiveRoute(activeRoute, `/${RECIPE_TAB}/${ITEM_TAB_NAME}/${id}/?ingredientTab=${TASTE_RECIPE_PROPERTIES}`),
        },
    ];
};

export const ingredientTabNavigationService = {
    observersList: [],
    getTabs(activeRoute, id, width) {
        return createRecipeIngredientsTabs(id, width, activeRoute);
    },
    getTabName() {
        return RECIPE_TAB;
    },
    registerTabsUpdateObserver(observer) {
        this.observersList.push(observer);
    },
    unRegisterTabsUpdateObserver(observer) {
        this.observersList = this.observersList.filter((observerFunction) => observerFunction !== observer);
    },
    notifyObservers() {
        this.observersList.forEach((observer) => observer());
    },
};
